/* eslint-disable */
var defaultFontStyle = 'Montserrat,sans-serif';
var defaultHeaderSize = '20px';
var defaultFontSize = '14px';
var defaultLegendItemSize = '14px';
var defaultChartColor = 'rgb(141, 168, 173)';
var defaultAxisLineColor = 'rgb(141, 168, 173)';
import store from '@/store/store';

const ChartOptions = {
	chart: {
		animation: true,
		events: {
			// "load": function() {
			// 	var yAxis = this.yAxis[0];
			// 	var extremes = yAxis.getExtremes();
			// 	var crossing = Math.abs(extremes.min) + Math.abs(extremes.max);
			// 	this.xAxis[0].update({
			// 	  offset: yAxis.toPixels(crossing, true)
			// 	});
			// },
			redraw: null
		},
		spacingBottom: 40,
		spacingTop: 20,
		style: {
			fontFamily: defaultFontStyle
		},
		zoomType: 'xy'
	},
	credits: {
		href: '',
		text: 'Source: Bloomberg, LCP research. ',
		style: {
			color: defaultChartColor,
			fontSize: defaultFontSize
		}
	},
	exporting: {
		enabled: false
	},
	legend: {
		borderRadius: 6,
		borderWidth: 1,
		enabled: false,
		itemStyle: {
			color: defaultChartColor,
			fontSize: defaultLegendItemSize,
			fontWeight: 'normal'
		}
	},
	plotOptions: {
		line: {
			stickyTracking: false,
			marker: {
				enabled: false
			}
		},
		series: {
			stickyTracking: false,
			events: {
				legendItemClick: function(e) {
					e.preventDefault();
				},
				click: (e) => {
					store.commit('chart/updateSelectedFund', e.point.info);
					store.commit('ui/setShowModal', true);
				}
			}
		},
		bubble: {
			minSize: 10,
			maxSize: 50
		},
		histogram: {
			binWidth: 0.2
		}
	},
	series: [],
	title: {
		style: {
			color: defaultChartColor,
			fontSize: defaultHeaderSize
		},
		text: ''
	},
	tooltip: {
		backgroundColor: 'White',
		borderRadius: 15,
		borderWidth: 1,
		followPointer: true,
		style: {
			color: defaultChartColor,
			fontSize: defaultLegendItemSize
		},
		useHTML: true,
		formatter: null,
		shared: true
	},
	xAxis: {
		labels: {
			style: {
				color: defaultChartColor,
				fontSize: defaultFontSize
			}
		},
		lineColor: defaultAxisLineColor,
		lineWidth: '2',
		title: {
			align: 'middle',
			style: {
				color: defaultChartColor,
				fontSize: defaultFontSize
			},
			text: ''
		},
		crosshair: true
	},
	yAxis: [
		{
			labels: {
				style: {
					color: defaultChartColor,
					fontSize: defaultFontSize
				}
			},
			lineColor: defaultAxisLineColor,
			title: {
				style: {
					color: defaultChartColor,
					fontSize: defaultFontSize
				},
				text: ''
			},
			crosshair: true
		},
		{
			labels: {
				style: {
					color: defaultChartColor,
					fontSize: defaultFontSize
				}
			},
			lineColor: defaultAxisLineColor,
			title: {
				style: {
					color: defaultChartColor,
					fontSize: defaultFontSize
				},
				text: ''
			}
		}
	]
};

function GeneralTooltip() {
	if (this.hasOwnProperty('point') && this.point.tooltip) {
		let displayAUM =  '';
		if (this.point.info.AUM !== null) {
			
			
			displayAUM = `£${Math.round(this.point.info.AUM / 100) / 10}bn`;
			if (this.point.info.AUM / 1000 < 1) {
				displayAUM = `£${this.point.info.AUM}m`;
			}
		}

		let displayFee = ``;
		if (this.point.info.Fee !== null) {
			displayFee = `${this.point.info.Fee}%`;
		}
		return `
			<div class="popover-title">
				<div title="Fundsmith Equity Fund" class="managerTitle">
					<b>${this.point.info.name}</b>
				</div>
				<div class="sector">${this.point.info['Asset class'] !== null ? this.point.info['Asset class'] : ''}</div>
			</div>
			<div class="popover-content">
				<div style="display: table">
				<div style="display: table-row">
				<div style="display: table-cell; padding-right: 10px">
					<span>Return (% - pa over 1y)</span>:
				</div>
				<div style="display: table-cell; color: #03a7cb;">
					${this.point.info['Return (% - pa over 1y)'] !== null ? `${Math.round(this.point.info['Return (% - pa over 1y)'] * 10) / 10}%` : ''}</span>
				</div>
			</div>
			<div style="display: table-row">
				<div style="display: table-cell; padding-right: 10px">
					<span>Standard deviation (% pa)</span>:
				</div>
				<div style="display: table-cell; color: #03a7cb;">
					${this.point.info['Standard deviation (% pa)'] !== null ? `${Math.round(this.point.info['Standard deviation (% pa)'] * 10) / 10}%` : ''}
				</div>
			</div>
			<div style="display: table-row">
				<div style="display: table-cell; padding-right: 10px"><span>Max drawdown</span>:</div>
				<div style="display: table-cell; color: #03a7cb;">${this.point.info['Max drawdown'] !== null ? `${Math.round(
					this.point.info['Max drawdown'] * 10
				) / 10}%` : ''}</div>
			</div>
			<div style="display: table-row">
				<div style="display: table-cell; padding-right: 10px"><span>Fee</span>:</div>
				<div style="display: table-cell; color: #03a7cb;">${displayFee}</div>
			</div>
			<div style="display: table-row">
				<div style="display: table-cell; padding-right: 10px"><span>Length of track record</span>:</div>
				<div style="display: table-cell; color: #03a7cb;">${this.point.info['Length of track record'] !== null ? `${Math.round(
					this.point.info['Length of track record'] * 10
				) / 10} years` : ''} </div>
			</div>
			<div style="display: table-row">
				<div style="display: table-cell; padding-right: 10px"><span>LCP rating</span>:</div>
				<div style="display: table-cell; color: #03a7cb;">${
					this.point.info['LCP rating'] !== null ? this.point.info['LCP rating'] : ''
				}</div>
			</div>
			<div style="display: table-row">
				<div style="display: table-cell; padding-right: 10px"><span>Beta to bonds</span>:</div>
				<div style="display: table-cell; color: #03a7cb;">${this.point.info['Beta to bonds'] !== null ? this.point.info['Beta to bonds'].toFixed(2) : ''}</div>
			</div>
			<div style="display: table-row">
				<div style="display: table-cell; padding-right: 10px"><span>Beta to equities</span>:</div>
				<div style="display: table-cell; color: #03a7cb;">${this.point.info['Beta to equities'] !== null ? this.point.info['Beta to equities'].toFixed(2) : ''}</div>
			</div>
			<div style="display: table-row">
				<div style="display: table-cell; padding-right: 10px"><span>LCP due dilligence passed</span>:</div>
				<div style="display: table-cell; color: #03a7cb;">${this.point.info['LcpDueDilligence'] !== null ? this.point.info['LcpDueDilligence'] : ''}</div>
			</div>
			<div style="display: table-row">
				<div style="display: table-cell; padding-right: 10px"><span>Open to new money</span>:</div>
				<div style="display: table-cell; color: #03a7cb;">${this.point.info['FundOpenOrClosed'] !== null ? this.point.info['FundOpenOrClosed'] : ''}</div>
			</div>
			<div style="display: table-row">
				<div style="display: table-cell; padding-right: 10px"><span>AUM</span>:</div>
				<div style="display: table-cell; color: #03a7cb;">${displayAUM}</div>
			</div>
			<div style="display: table-row">
				<div style="display: table-cell; padding-right: 10px"><span>Client exposure</span>:</div>
				<div style="display: table-cell; color: #03a7cb;">${this.point.info['Client exposure'] !== null ? `£${this.point.info['Client exposure']}m` : ''}</div>
			</div>
			<div style="display: table-row">
				<div style="display: table-cell; padding-right: 10px"><span>Number of clients</span>:</div>
				<div style="display: table-cell; color: #03a7cb;">${this.point.info['Number of clients'] !== null ? this.point.info['Number of clients'] : ''}</div>
			</div>
		</div>
	</div>`;
	} else {
		return false;
	}
}

function InfastructureTooltip() {
	if (this.hasOwnProperty('point') && this.point.tooltip) {
		let displayAUM =  'Unavailable';
		if (this.point.info.AUM !== null) {
			displayAUM = `£${Math.round(this.point.info.AUM / 100) / 10}bn`;
			if (this.point.info.AUM / 1000 < 1) {
				displayAUM = `£${this.point.info.AUM}m`;
			}
		}
		return `
		<div class="popover-title">
		<div title="Fundsmith Equity Fund" class="managerTitle">
			<b>${this.point.info.name}</b>
		</div>
		<div class="sector">${this.point.info['Asset class']}</div>
	</div>
	<div class="popover-content">
		<div style="display: table">
			<div style="display: table-row">
				<div style="display: table-cell; padding-right: 10px"><span>Expected return (% pa)</span>:</div>
				<div style="display: table-cell; color: #03a7cb;">${
					this.point.info['Expected return (% pa)']
						? this.point.info['Expected return (% pa)']
						: ''
				}</div>
			</div>
			<div style="display: table-row">
				<div style="display: table-cell; padding-right: 10px"><span>Cash yield (% pa)</span>:</div>
				<div style="display: table-cell; color: #03a7cb;">${
					this.point.info['Cash yield (% pa)']
						? this.point.info['Cash yield (% pa)']
						: ''
				}</div>
			</div>
			<div style="display: table-row">
				<div style="display: table-cell; padding-right: 10px"><span>AUM</span>:</div>
				<div style="display: table-cell; color: #03a7cb;">${displayAUM}</div>
			</div>
			<div style="display: table-row">
				<div style="display: table-cell; padding-right: 10px"><span>Expected time to drawdown (months)</span>:</div>
				<div style="display: table-cell; color: #03a7cb;">${
					this.point.info['Expected time to drawdown (months)']
						? this.point.info['Expected time to drawdown (months)']
						: ''
				}</div>
			</div>
			<div style="display: table-row">
				<div style="display: table-cell; padding-right: 10px"><span>Solvency capital ratio (estimate)</span>:</div>
				<div style="display: table-cell; color: #03a7cb;">${
					this.point.info['Solvency capital ratio (estimate)']
						? this.point.info['Solvency capital ratio (estimate)']
						: ''
				}</div>
			</div>
		</div>
	</div>`;
	} else {
		return false;
	}
}

export { ChartOptions, GeneralTooltip, InfastructureTooltip };
